import { reactive } from 'vue'
import { turnToConfig } from 'init/config'

/**
 * Interface for the state property inside the store
 */
export interface ITopCommentsStoreState {
  tags?: Array<string>
}

/**
 * The store class itself. An instance is created below and exported as
 * the default export.
 */
export class Store {
  constructor() {
    const clientTopCommentsConfig = turnToConfig.topComments || {}
    this.state.tags = clientTopCommentsConfig.tags || []
  }

  state: ITopCommentsStoreState = reactive({
    tags: []
  })

  set tags(tags: Array<string>) {
    this.state.tags = tags
  }
  get tags(): Array<string> {
    return this.state.tags
  }
}

export default new Store()
